import { render, staticRenderFns } from "./SaleEditRowImage.vue?vue&type=template&id=715d9ff6&scoped=true"
import script from "./SaleEditRowImage.vue?vue&type=script&lang=ts"
export * from "./SaleEditRowImage.vue?vue&type=script&lang=ts"
import style0 from "./SaleEditRowImage.vue?vue&type=style&index=0&id=715d9ff6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715d9ff6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('715d9ff6')) {
      api.createRecord('715d9ff6', component.options)
    } else {
      api.reload('715d9ff6', component.options)
    }
    module.hot.accept("./SaleEditRowImage.vue?vue&type=template&id=715d9ff6&scoped=true", function () {
      api.rerender('715d9ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditRowImage.vue"
export default component.exports